module.exports = __webpack_public_path__ + "img/biaoqian_binguan.358608b9.png";